<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">จัดการรายชื่อผู้ดูแลระบบ</h2>
    </div>
    <div class="pd-b-3 flex-display js-between ai-center">
      <div>
        <p v-if="showSearch" class="mg-y-less">
          <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
        </p>
      </div>

      <div class="flex-display">
        <el-form @submit.prevent.native ref="formSignin">
          <el-input
            placeholder="ค้นหารายชื่อผู้ดูแลระบบ"
            prefix-icon="el-icon-search"
            class="search-input"
            @blur="showInputSearch = false,!searchText && showSearch?search():null"
            @keyup.enter.native="search"
            @clear="searchText = '',search()"
            :class="{ show: showInputSearch }"
            clearable
            ref="search"
            v-model="searchText"
          >
          </el-input>

          <el-button
            v-if="!showInputSearch"
            @click="openSearchInput"
            icon="el-icon-search"
            round
            class="pd-x-2 primary border-color-primary"
            >ค้นหา</el-button
          >
        </el-form>
        <el-button
          @click="$router.push('/admin/create')"
          type="primary"
          class="mg-l-4"
          round
          >เพิ่มผู้ดูแลระบบ</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        v-if="showTable"
        :data="instructorList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        v-loading="loading"
        empty-text="ไม่พบข้อมูล"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="60"
          :index="(index) => indexMethod(index, page, pageSize)"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อ-นามสกุล"
          header-align="center"
          :width="widthMax < 767.98 ? '180' : ''"
        >
          <template slot-scope="scope">
            {{ getPrefixLabel(scope.row.titleName) }} {{ scope.row.nameTH }}
            {{ scope.row.surnameTH }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mobilephone"
          label="หมายเลขโทรศัพท์"
          width="120"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="email"
          label="อีเมล"
          :width="widthMax < 991.98 ? '180' : '200'"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่อัปเดตล่าสุด"
          :width="widthMax < 991.98 ? '220' : '250'"
          header-align="center"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.updatedAt | dateTimeTh }}
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="80"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="
                    $router.push(
                      `/admin/update?adminId=${scope.row._id}`
                    )
                  "
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delInstructor(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="totalInstructor > pageSize" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalInstructor"
        :page-size="pageSize"
        :current-page="page"
      >
      </el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  routeParams: {
    type: Object,
    default: null,
  },
  components: {
    DashboardTemplate,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      instructorList: [],
      searchText: "",
      showInputSearch: false,
      page: 1,
      pageSize: 10,
      totalInstructor: 0,
      loading: true,
      showSearch: false,
    };
  },
  mounted() {
    this.fetchAdmins();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    delInstructor(id) {
      this.loading = true;
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.delete(`admin/${id}`)
        .then((res) => {
          if (res.data.success) {
            this.fetchAdmins();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delInstructor error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    fetchAdmins() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(
        `admins/${(this.page - 1) * this.pageSize}/${this.pageSize}/${
          this.searchText ? this.searchText : "all"
        }`
      )
        .then((res) => {
          if (res.data.success) {
            this.instructorList = res.data.obj;
            this.totalInstructor = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchAdmins error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchAdmins();
    },
    search() {
      this.loading = true;
      this.page = 1
      this.fetchAdmins();
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>

<style scoped></style>
